import { render, staticRenderFns } from "./DbpyPL.vue?vue&type=template&id=02174889"
import script from "./DbpyPL.vue?vue&type=script&lang=js"
export * from "./DbpyPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports